import React from "react";
import axios from "axios";
import { GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { API } from "../constants";

/**
 * Direct Google OAuth sign-in button (replaces the prior Emergent-managed flow).
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function GoogleSignInButton() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSuccess = async (resp) => {
    if (!resp?.credential) {
      toast.error("Google sign-in cancelled");
      return;
    }
    try {
      const res = await axios.post(`${API}/auth/google`, { credential: resp.credential });
      const { token, user } = res.data;
      login(user, token);
      toast.success(`Welcome, ${user.name || user.email}`);
      navigate("/dashboard");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Google sign-in failed");
    }
  };

  return (
    <div className="flex justify-center" data-testid="google-signin-wrapper">
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={() => toast.error("Google sign-in failed")}
        theme="filled_black"
        size="large"
        shape="pill"
        text="continue_with"
      />
    </div>
  );
}
